<template>
	<div class="comp">
		<el-dialog title="复购提醒" :visible.sync="dialog_state" @close="close" width="800px">
			<el-form @submit.native.prevent>
				<el-row>
					<el-col>
						<el-table :data="buyBackList" style="width: 100%">
							<el-table-column prop="no" label="商品名称" >
								<template slot-scope="scope">
									{{scope.row.goods_name}}
								</template>
							</el-table-column>
							<el-table-column label="规格">
								<template slot-scope="scope">
									{{scope.row.sku_value}}
								</template>
							</el-table-column>
							<el-table-column label="提醒时间" width="220">
								<template slot-scope="scope">
									<el-date-picker
										style="width: 200px;"
										v-model="scope.row.buyBackTime"
										clearable="false"
										type="datetime"
										size="mini"
										placeholder="选择日期时间">
									</el-date-picker>
								</template>
							</el-table-column>
							<el-table-column prop="zip" label="宠物" >
								<template slot-scope="scope">
									<el-select
									v-model="scope.row.pets_info.pets_id"
									placeholder="请选择"
									size="mini">
										<el-option popper-class="select" v-for="item in userInfo.pets_info" :key="item._id" :label="item.nick_name"
										:value="item._id"></el-option>
									</el-select>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="close">稍后处理</el-button>
				<el-button type="primary" size="small" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				dialog_state:false,
				
				detail:{},
				buyBackList:[],
				
				userInfo:{
					pets_info:[]
				}
				
			}
		},
		computed:{
			
		},
		props:{
			orderId:{
				default:''
			}
		},
		mounted(){
			this.getDetail();
			this.$nextTick(()=>{
				this.dialog_state = true
			})
		},
		methods: {
			close(){
				this.$emit("submit",{type:"close"})
			},
			submit(){
				let petProductList = []
				for(let i=0;i<this.buyBackList.length;i++){
					if(!this.$public.isNull(this.buyBackList[i].buyBackTime)){
						petProductList.push({
							"goodsId": this.buyBackList[i].goods_id,
							"goodsName": this.buyBackList[i].goods_name,
							"goodsType": this.buyBackList[i].goods_type,
							"firstCategory": {
								"categoryId": "",
								"categoryName": "",
								"categoryCode": ""
							},
							"secondCategory": {
								"categoryId": this.buyBackList[i].category_info.category_id,
								"categoryName":  this.buyBackList[i].category_info.name,
								"categoryCode":  this.buyBackList[i].category_info.code,
							},
							"brand": this.buyBackList[i].brand,
							"skuId": this.buyBackList[i].skus_id,
							"skuName": this.buyBackList[i].sku_value,
							"unitId": this.buyBackList[i].packing_way_id,
							"unitName": this.buyBackList[i].unit,
							"petId": this.buyBackList[i].pets_info.pets_id,
							"petName":this.$public.getMatchingItem(this.userInfo.pets_info,'_id',this.buyBackList[i].pets_info.pets_id).nick_name,
							"nextDate":this.$public.FTimeStr10(this.buyBackList[i].buyBackTime),
						})
					}
				}
				let params = {
					"orderNo": this.detail.no,
					"memberInfo": {
						"memberId": this.detail.user_info.user_id,
						"memberName": this.detail.user_info.nick_name,
						"memberMobile":  this.detail.user_info.user_mobile,
						"remark": "",
					},
					"petProductList":petProductList,
				}
				console.log(params)
				this.$http.post(process.env.VUE_APP_Url_8020+'/api/BuyBack/Insert', params).then(res => {
					if(res.code==0){
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$emit("submit",{type:"success",data:res.data})
					}
				})
			},
			getDetail(){
				let params = {
					orderid: this.orderId,
				}
				this.$http.get('/api/Order/GetOrder', params).then(res => {
					if(res.code===0){
						this.detail = res.data;
						let buyBackList = []
						if(!this.$public.isNull(res.data.order_item_list)){
							for(let i=0;i<res.data.order_item_list.length;i++){
								let item = res.data.order_item_list[i]
								this.$set(item,'buyBackTime','')
								if(item.buy_back===1){
									buyBackList.push(item)
								}
							}
						}
						this.buyBackList = buyBackList
						this.getUserInfo(res.data.user_info.user_id)
					}
				})
			},
			getUserInfo(userId){
				let params = {
					"id": userId,
				}
				this.$http.get('/api/Member/Single', params).then(res => {
					if(res.code==0){
						this.userInfo = res.data
					}
				})
			}
		}
	}
</script>
<style scoped lang="scss">
.page{
	.pageTitleBox{
	}
	.msg {
		display: flex;
		flex-wrap: wrap;
		background-color: #fff;
		border-radius: 4px;
		.msgItem {
			width: 25%;
			font-size: 16px;
			color: $fontColor;
			display: flex;
			line-height: 40px;
			padding:0 20px;
			box-sizing: border-box;
			border-bottom:1px solid #F2F2F2;
			font-size: 12px;;
			.msgLabel {
				width: 80px;
				text-align: right;
				color: $fontColor;
			}
	
			.msgValue {}
		}
	}
	.pageConBox{
		min-height: 600px;
		margin-top:12px;
	}
}
</style>
